<template>
  <Modal>
    <Modal.Title>Remove potential infringing file?</Modal.Title>
    <Modal.Body>
      <p class="text-[14px] leading-[22px] text-gray-800">
        Are you sure you want to remove the uploaded file? Once removed the file
        will be lost.
      </p>
    </Modal.Body>
    <Modal.Footer>
      <Button
        variant="stroke"
        :size="isMobile ? 'lg' : 'md'"
        @click="closeModal()"
      >
        Cancel
      </Button>
      <Button
        variant="primary"
        :size="isMobile ? 'lg' : 'md'"
        @click="handleRemove"
      >
        Remove
      </Button>
    </Modal.Footer>
  </Modal>
</template>

<script setup lang="ts">
import { Modal, Button, useModal } from '@dacr/library'
import { useDevice } from '@/shared/composables/useDevice'
import { closeModal } from '@/shared/dialogs/modals'

const { isMobile } = useDevice()
const { triggerEvent } = useModal()

const handleRemove = () => {
  triggerEvent('success')
  closeModal()
}
</script>
